export default __webpack_public_path__ + "static/media/icon_status_ia.4ee521c6.svg";